import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseService} from './base.service';
import {IEretailSupplier} from '../models/supplier/eretailSupplier';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {IEretailFieldComment} from '../models/product/eretailPreProduct';

export interface SupplierApiResponse {
  novosFornecedores: IEretailSupplier[];
  total: number;
}

export interface SupplierDetailApiResponse {
  documentos: any;
  novoFornecedor: IEretailSupplier;
  usuarioId: number;
}

export interface GetSuppliersParam {
  nomeSolicitante?: string;
  razaoSocial?: string;
  email?: string;
  cnpj?: string;
  status?: number;
  pagina?: number;
  totalPorPagina?: number;
}

@Injectable({providedIn: 'root'})
export class SupplierService extends BaseService<IEretailSupplier> {
  path: string = '/NovosFornecedores';

  constructor(http: HttpClient) {
    super('NovosFornecedores', http);
  }

  getDetail(id: number): Observable<SupplierDetailApiResponse> {
    return this.http.get<SupplierDetailApiResponse>(`${environment.apiUrl}${this.path}/${id}`);
  }
 

  getByParams(params: GetSuppliersParam): Observable<SupplierApiResponse> {
    let httpParams = new HttpParams();

    if (params.nomeSolicitante) {
      httpParams = httpParams.set('nomeSolicitante', params.nomeSolicitante);
    }
    if (params.razaoSocial) {
      httpParams = httpParams.set('razaoSocial', params.razaoSocial);
    }
    if (params.email) {
      httpParams = httpParams.set('email', params.email);
    }
    if (params.cnpj) {
      httpParams = httpParams.set('cnpj', params.cnpj);
    }
    if (params.status) {
      httpParams = httpParams.set('status', params.status.toString());
    }
    if (params.pagina) {
      httpParams = httpParams.set('pagina', params.pagina.toString());
    }
    if (params.totalPorPagina) {
      httpParams = httpParams.set('totalPorPagina', params.totalPorPagina.toString());
    }

    return this.http.get<SupplierApiResponse>(`${environment.apiUrl}${this.path}`, {params: httpParams});
  }

  approvePreRegister(id: number, fieldComments?: IEretailFieldComment[]): Observable<IEretailSupplier> {
    return this.http.post<IEretailSupplier>(`${environment.apiUrl}${this.path}/aprovar-pre-cadastro/${id}`, fieldComments);
  }

  approveCompleteRegister(id: number, fieldComments?: IEretailFieldComment[]): Observable<IEretailSupplier> {
    return this.http.post<IEretailSupplier>(`${environment.apiUrl}${this.path}/aprovar-cadastro-completo/${id}`, fieldComments);
  }

  reject(id: number, fieldComments?: IEretailFieldComment[]): Observable<IEretailSupplier> {
    return this.http.post<IEretailSupplier>(`${environment.apiUrl}${this.path}/reprovar/${id}`, fieldComments);
  }

  sendNewSupplierToApproval(newSupplier: Partial<IEretailSupplier>): Observable<any> {
    return this.http.post<SupplierApiResponse>(`${environment.apiUrl}${this.path}`, newSupplier);
  }

  editSupplier(newSupplier: Partial<IEretailSupplier>): Observable<any> {
    return this.http.put<any>(`${environment.apiUrl}${this.path}/completar-ficha`, newSupplier);
  }

  getDocumentsBySupplierId(id: number): Observable<any> {
    return this.http.get<SupplierDetailApiResponse>(
      `${environment.apiUrl}${this.path}/get-files-by-fornecedor-id?fornecedorId=${id}`
    );
  }
}
